import { render, staticRenderFns } from "./tradeLeft.vue?vue&type=template&id=2605fde7&scoped=true&"
import script from "./tradeLeft.vue?vue&type=script&lang=js&"
export * from "./tradeLeft.vue?vue&type=script&lang=js&"
import style0 from "./tradeLeft.vue?vue&type=style&index=0&id=2605fde7&scoped=true&lang=scss&"
import style1 from "./tradeLeft.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605fde7",
  null
  
)

export default component.exports